import * as Sentry from '@sentry/react';

// Only init Sentry when an environment is set
if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: 'https://ce5b813d425f06c5fa96846d04124e34@o395617.ingest.us.sentry.io/4508429811843072',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Only enable Sentry in non-development environments
    enabled: import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'development',
  });
}
